import Vue from "vue";

import { storeInstance, routerInstance, vueI18nInstance } from "@mods/index.js";
import routes from "./router/index";
import routerRoot from "./router/root";
import locale from "./locale/index";
import store from "./store/index";
import mixins from "./mixins";
import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV != "production";

Vue.mixin(mixins);
new Vue({
    el: "#app",
    i18n: vueI18nInstance(locale),
    router: routerInstance(routes, routerRoot),
    store: storeInstance(store)
});
